import { useEffect, useState } from 'react';
import SnackBar from 'components/SnackBar';
import FormGroup from '../../FormGroup';
import SectionHeader from '../../SectionHeader';
import usePostData from '../../../hooks/usePostData';
import useFetchData from '../../../hooks/useFetchData';
import fields from '../fields';
import { useParams } from 'react-router-dom';
import translating from '../translate.json';

import '../styles.scss';

const GeneParamPage = () => {
  const { idd } = useParams();
  const [currentGene, setCurrentGene] = useState();
  const [currentText, setCurrentText] = useState();
  const { data: reportTextData } = useFetchData('report-text');
  const { data: subCategoriesData } = useFetchData('report-text/SubCategoris');
  const {
    postData: genePostData,
    res: geneRes,
    payload,
    error: genError
  } = usePostData();
  const {
    postData: textPostData,
    res: textRes,
    error: textError
  } = usePostData();
  const [showSnackbar, setShowSnakbar] = useState(false);
  const [errFun, setErrFun] = useState();

  let { data } = useFetchData('gene-analyze', idd);

  useEffect(() => {
    setCurrentGene(data?.gene);
    setCurrentText(data?.text);
  }, [data]);

  useEffect(() => {
    if (genError)
      errFun?.set('apiError', {
        type: 'string',
        message: genError.apiError
      });
    else if (geneRes && geneRes.affected === 1 && payload) {
      setCurrentGene(payload);
      setShowSnakbar(true);
    }
  }, [geneRes, payload, genError]);

  useEffect(() => {
    if (genError)
      errFun?.set('apiError', {
        type: 'string',
        message: textError.apiError
      });
    else if (geneRes && geneRes.affected === 1) {
      setShowSnakbar(true);
    }
  }, [textRes, textError]);

  const onSubmit = (data, setError) => {
    setErrFun({ set: setError });
    let deepData = { ...data };
    delete deepData.id;
    console.log('update user data  :', deepData);
    genePostData(`gene-analyze/${idd}`, deepData, 'patch');
  };

  const onSubmitTxt = (data, setError) => {
    setErrFun({ set: setError });
    let deepData = { ...data };
    delete deepData.id;
    console.log('update user data  :', deepData);
    textPostData(`report-text/${currentText.textId}`, deepData, 'patch');
  };

  return (
    <div className="gene-edit">
      {currentGene && (
        <div>
          <div>
            <SectionHeader
              title={`${translating.genotip} ${currentGene?.Gene}`}
            ></SectionHeader>
            <FormGroup
              fields={fields(subCategoriesData, reportTextData)}
              data={currentGene}
              onSubmit={onSubmit}
            ></FormGroup>
          </div>
          <div className="text-edit">
            <SectionHeader title={`${translating.txt}`}></SectionHeader>
            <FormGroup
              fields={[
                {
                  type: 'textarea',
                  name: 'reportText',
                  label: translating.txt,
                  required: true
                }
              ]}
              data={currentText}
              onSubmit={onSubmitTxt}
            ></FormGroup>
          </div>
          {showSnackbar && (
            <SnackBar
              msg={'מדד עודכן'}
              handleClose={() => setShowSnakbar(false)}
            ></SnackBar>
          )}
        </div>
      )}
    </div>
  );
};

export default GeneParamPage;
